import useUIState from './persistUiState';
import { UIFeature } from './types';

export interface NavbarExpandedUIState {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

export const useNavbarExpandedUIState = (
  feature: UIFeature,
): NavbarExpandedUIState =>
  useUIState((state) => ({
    expanded: state.navBarExpanded[feature],
    setExpanded: (expanded) => state.setNavBarExpanded(feature, expanded),
  }));
